module.exports = __webpack_public_path__ + "img/2322cebf66f33b3fcd5b31239b39b30b.png";